// Report availability is independent of trading/listing eligibility.
export async function loadReportCatalog(http) {
  const response = await http.get('/api/conghua/basicInfo/list?include_reported=1');
  if (!Array.isArray(response.data)) throw new Error('Report catalog unavailable');
  return response.data;
}
